export function VultMark({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M15 20L45 80L85 20H68L45 62L32 20H15Z" fill="#0F172A" />
      <path d="M45 80L85 20H72L45 68L45 80Z" fill="#FFD600" />
    </svg>
  );
}

export function VultLogo({ size = 36, dark = false }) {
  return (
    <span className="flex items-center gap-2">
      <VultMark size={size} />
      <span className={`font-display text-2xl font-black italic tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
        VULT<span className="text-vult-red">.</span>
      </span>
    </span>
  );
}
